import { IOpsPortalCollectionsDetails } from '@schemas/opsPortal/types/collectionsDetails';

export const getIsInArrears = (
  collectionsData: IOpsPortalCollectionsDetails | undefined,
) => Boolean(parseFloat(collectionsData?.arrears_amount?.amount ?? ''));
